import { useDispatch } from "react-redux"
import React, { useState } from "react"
import { login } from "../../../redux/store/auth/authSlice"
import { TAlogin } from "../../../services/authAPI"
import { getErrorMessage } from "../../../types/error"

const LoginScreen = () => {
  const dispatch = useDispatch()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState<string | null>(null)

  const handleForm = async (e: any) => {
    e.preventDefault()

    if (email === "") {
      setError("Email is required")
    } else if (password === "") {
      setError("Password is required")
    } else {
      setError(null)
      handleLogin()
    }
  }

  const handleLogin = async () => {
    try {
      const response = await TAlogin(email, password)
      localStorage.setItem("token", response.token)
      if (response) {
        dispatch(
          login({
            user: email,
            token: response.token,
          }),
        )
      }
      window.location.reload()
    } catch (error: unknown) {
      setError(getErrorMessage(error) || "Login failed")
    }
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-cover bg-center bg-[url('./assets/images/map.svg')] dark:bg-[url('./assets/images/map-dark.svg')]">
      <div className="panel sm:w-[480px] m-6 max-w-lg w-full">
        <h2 className="font-bold text-2xl mb-3">Giriş Yap</h2>
        <p className="mb-7">Giriş yapmak için Email ve şifrenizi girin</p>
        <form className="space-y-5" onSubmit={handleForm}>
          <div>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              className="form-input"
              placeholder="Email girin"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-cy="login-email"
            />
          </div>
          <div>
            <label htmlFor="password">Şifre</label>
            <input
              id="password"
              type="password"
              className="form-input"
              placeholder="Şifre girin"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-cy="login-password"
            />
          </div>
          {error && (
            <div className="text-center text-red-500" data-cy="login-error">
              <p>{error}</p>
            </div>
          )}
          <button type="submit" className="btn btn-primary w-full" data-cy="login-submit">
            GİRİŞ YAP
          </button>
        </form>
        <div className="relative my-7 h-5 text-center before:w-full before:h-[1px] before:absolute before:inset-0 before:m-auto before:bg-[#ebedf2] dark:before:bg-[#253b5c]">
          <div className="font-bold text-white-dark bg-white dark:bg-black px-2 relative z-[1] inline-block"></div>
        </div>
        {/* <p className="text-center">
          Dont&apos;t have an account ?
          <Link
            to="/auth/register"
            className="font-bold text-primary hover:underline ltr:ml-1 rtl:mr-1"
          >
            Sign Up
          </Link>
        </p> */}
      </div>
    </div>
  )
}

export default LoginScreen
